import { render, staticRenderFns } from "./CheckoutTestCard.vue?vue&type=template&id=5c689c8c&scoped=true"
import script from "./CheckoutTestCard.vue?vue&type=script&lang=js"
export * from "./CheckoutTestCard.vue?vue&type=script&lang=js"
import style0 from "./CheckoutTestCard.vue?vue&type=style&index=0&id=5c689c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c689c8c",
  null
  
)

export default component.exports